import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useMemo } from 'react';
import Login from '../pages/Login';
import Layout from '../components/Layout';
import { ProtectedRoute } from '../components/ProtectedRoute';
import ProfileManagement from '../components/profile/ProfileManagement';
import CollectionDashboard from '../pages/CollectionDashboard';
import AgentDashboard from '../pages/AgentDashboard';
import BorrowerProfile from '../pages/BorrowerProfile';
import LoandiskBorrowerProfile from '../pages/LoandiskBorrowerProfile';
import AgentBorrowerList from '../pages/AgentBorrowerList';
import CollectionAgencyList from '../pages/CollectionAgencyList';
import BorrowerAccountDetails from '../pages/BorrowerAccountDetails';
import BorrowerUpdates from '../pages/BorrowerUpdates';
import LeaveApplication from '../pages/LeaveApplication';
import CiQueue from '../pages/CiQueue';
import CiCapture from '../pages/CiCapture';
import ItineraryPlanner from '../pages/ItineraryPlanner';
import ApprovedItinerary from '../pages/ApprovedItinerary';

export default function AppRoutes() {
  const { session, userProfile } = useAuth();

  // Agents land on the agent dashboard; everyone else (superagent, admin) on
  // the collection dashboard. This app only serves agent/superagent pages.
  const defaultRoute = useMemo(() => {
    if (userProfile?.role === 'agent') return '/agent-dashboard';
    return '/collection-dashboard';
  }, [userProfile]);

  return (
    <Routes>
      <Route path="/login" element={!session ? <Login /> : <Navigate to="/" replace />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route index element={<Navigate to={defaultRoute} replace />} />
                <Route path="/profile" element={<ProfileManagement />} />
                <Route path="/collection-dashboard" element={<CollectionDashboard />} />
                <Route path="/agent-dashboard" element={<AgentDashboard />} />
                <Route path="/my-borrowers" element={<AgentBorrowerList />} />
                <Route path="/borrower/:id" element={<BorrowerProfile />} />
                <Route path="/loandisk-borrower/:uniqueNumber" element={<LoandiskBorrowerProfile />} />
                <Route path="/collection-list" element={<CollectionAgencyList />} />
                <Route path="/ci-queue" element={<CiQueue />} />
                <Route path="/ci/:id" element={<CiCapture />} />
                <Route path="/leave-application" element={<LeaveApplication />} />
                <Route path="/borrower-accounts/:loandiskId/:borrowerId" element={<BorrowerAccountDetails />} />
                <Route path="/borrower-updates" element={<BorrowerUpdates />} />
                <Route path="/itinerary-planner" element={<ItineraryPlanner />} />
                <Route path="/approved-itinerary" element={<ApprovedItinerary />} />
                <Route path="*" element={<Navigate to={defaultRoute} replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
